<template>
	<div id="app">
		<transition name="fade" mode="out-in">
			<router-view></router-view>
		</transition>
	</div>
</template>
<script>
export default {
	name: 'app',
	components: {
		
	}
}
</script>

<style lang="scss">
body {
	margin: 0px;
	padding: 0px;
	font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, SimSun, sans-serif;
	font-size: 14px;
	-webkit-font-smoothing: antialiased;
  }

#app {
	position: absolute;
	top: 0px;
	bottom: 0px;
	width: 100%;
}

.el-submenu [class^=fa] {
	vertical-align: baseline;
	margin-right: 10px;
}

.el-menu-item [class^=fa] {
	vertical-align: baseline;
	margin-right: 10px;
}

.toolbar {
	background: #f2f2f2;
	padding: 10px;
	margin: 10px 0px;
	.el-form-item {
		margin-bottom: 10px;
	}
}

.fade-enter-active,
.fade-leave-active {
	transition: all .2s ease;
}

.fade-enter,
.fade-leave-active {
	opacity: 0;
}

	.showCon .el-dialog .el-dialog__body{
		height: 221px;
	}
	 .editEmployee .el-dialog__body{
			 overflow-y: inherit;
	}
	
// 	.listTable .el-table_1_column_7 .cell{
// 		top:-13px !important;
// 	}
// 	.listTable .el-table_1_column_8 .cell{
// 		top:-13px !important;
// 	}
	#tableCon .el-input__inner{
	    height: 50px;
	    line-height: 50px;
	    margin-top: -5px;
		}
	#tableCon .dayClass .el-input__inner{
		top:-2px;
	}
	#tableCon .el-date-editor .el-range-separator {
	    line-height: 41px;
	}
	
	#editId .ql-editor{
		min-height:400px;
	}
	
	.selectIn .el-drawer__body{
		padding-left: 20px !important;
	}
	#cloudImg2 .pa_look_img_list .cols:last-child {
		display: none !important;
	}
	
// 	#uploadVideo1 .v-modal{
// 		z-index: 2000 !important;
// 		background: #ffffff !important;
// 	}
	 .v-modal{
		z-index: 2000 !important;
	}
	.drawer .el-drawer.ltr, .el-drawer.rtl, .el-drawer__container{
		overflow-y: auto;
	}
	.drowCon .el-drawer.ltr, .el-drawer.rtl, .el-drawer__container{
		overflow-y: auto;
	}
	
	
   .selWarpper .el-input{
		margin-top: -1px;
	}
	.selWarpper .el-input__inner{
		border-radius: 0;
		height:50px;
	}
	
	.selWarpper .coupon2 .el-input__inner{
		border-radius: 0;
		height:40px;
	}
	.selWarpper .coupon4 .el-input__inner{
		border-radius: 0;
		height:40px;
	}


.el-tabs__content{
	background: #f8f8f8;
}
.textArea1 .el-textarea__inner{
	border-left: none !important;
}
.el-main{
	padding: 18px 0 0 18px !important;
	box-sizing: border-box;
}

</style>


// WEBPACK FOOTER //
// App.vue?1f1a9871